export const environment = {
  name: 'Staging',
  version: '2.48.0.6587',
  production: true,
  sentry: {
    dsn: 'https://8a567cbe1759408a82f0600370df4e02@sentry.antony-it.de/24',
    environment: 'Staging',
  },
  mock: false,
  authentication: {
    tokenName: 'auth-token',
  },
};
